import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ThirdPartsInqomAuthenticationService } from './inqom/services/third-parts-inqom-authentication.service';
import { CommonThirdPartsAuthenticationService } from './common/services/common-third-parts-authentication.service';
import { ThirdPartsStripeAuthenticationService } from './stripe/services/third-parts-stripe-authentication.service';
import { ThirdPartsPaypalAuthenticationService } from './paypal/services/third-parts-paypal-authentication.service';
import { ThirdPartsGoCardlessAuthenticationService } from './gocardless/services/third-parts-gocardless-authentication.service';
import { ThirdPartsQontoAuthenticationService } from './qonto/services/third-parts-qonto-authentication.service';
import { ThirdPartsAlmaAuthenticationService } from '~modules/thirdparts/alma/services/third-parts-alma-authentication.service';
import { ThirdPartsAxonautAuthenticationService } from './axonaut/services/third-parts-axonaut-authentication.service';
import { ThirdPartsCashAndRepairAuthenticationService } from '~modules/thirdparts/cash-and-repair/services/third-parts-cash-and-repair-authentication.service';
import { ThirdPartsNextMotionAuthenticationService } from './next-motion/services/third-parts-next-motion-authentication.service';
import { ThirdPartsLibeoAuthenticationService } from './libeo/services/third-parts-libeo-authentication.service';
import { ThirdPartsVosFacturesAuthenticationService } from './vosfactures/services/third-parts-vosfactures-authentication.service';
import { CommonThirdPartsConfigurationFetcherService } from '~modules/thirdparts/common/services/common-third-parts-configuration-fetcher.service';
import { ThirdPartsQontoRegateAuthenticationService } from './qonto-regate/services/third-parts-qonto-regate-authentication.service';
import { ThirdPartsZervantAuthenticationService } from './zervant/services/third-parts-zervant-authentication.service';



@NgModule({
  imports: [
    HttpClientModule
  ]
})
export class ThirdPartsModule {
  static forRoot(): ModuleWithProviders<ThirdPartsModule> {
    return {

      ngModule: ThirdPartsModule,
      providers: [
        // common
        CommonThirdPartsAuthenticationService,
        CommonThirdPartsConfigurationFetcherService,
        // inqom
        ThirdPartsInqomAuthenticationService,
        // stripe
        ThirdPartsStripeAuthenticationService,
        // paypal
        ThirdPartsPaypalAuthenticationService,
        // gocardless
        ThirdPartsGoCardlessAuthenticationService,
        // qonto
        ThirdPartsQontoAuthenticationService,
        // alma
        ThirdPartsAlmaAuthenticationService,
        // Axonaut
        ThirdPartsAxonautAuthenticationService,
        // Cash and repair
        ThirdPartsCashAndRepairAuthenticationService,
        // NextMotion
        ThirdPartsNextMotionAuthenticationService,
        // Libeo
        ThirdPartsLibeoAuthenticationService,
        // VosFactures
        ThirdPartsVosFacturesAuthenticationService,
        // Qonto Regate
        ThirdPartsQontoRegateAuthenticationService,
        // Zervant
        ThirdPartsZervantAuthenticationService
      ],
    };
   }
}
